// DIESMAX · asistente de la tienda (Signo Studio), con respuestas predeterminadas (sin IA).
// Lee las piezas reales de la tienda (/products.json de la misma tienda), arma window.ASISTENTE y
// carga asistente.js. Contesta con datos de Shopify: número de parte, equivalencias y claves de la
// ficha técnica (FF213 → GP-11), precio, marca, presentación y si es "solo Zacatecas"; envío por
// peso, pago, factura, devoluciones (7 días), garantía, ubicación, marcas y mayoreo.
// Lo que no sabe con certeza (si le queda a un camión) lo manda a WhatsApp con el VIN.
// No usa llaves ni servicios de fuera. Todo se pinta con textContent dentro de asistente.js.
'use strict';

(() => {
  let CFG = {};
  try { CFG = JSON.parse(document.getElementById('dm-config').textContent); } catch (e) { return; }
  if (!CFG.asistente) return;
  const R = CFG.rutas || {};
  const RAIZ = (R.raiz || '/').replace(/\/$/, '');
  const NEGOCIO = CFG.negocio || 'DIESMAX';
  const WA = String(CFG.whatsapp || '').replace(/\D/g, '');
  const MAX = Number(CFG.max) || 5;
  const TIENDA = CFG.tienda || 'JGL Diesel';
  const CORREO = CFG.correo || '';
  const KM = Number(CFG.entregaKm) || 10;
  const DIAS = CFG.envioDias || '5 a 8 días hábiles';
  const ENVIO = Array.isArray(CFG.envio) && CFG.envio.length ? CFG.envio : [[2000, 'Hasta 2 kg', 190], [8000, 'De 2 a 8 kg', 220], [null, 'Más de 8 kg', 300]];
  const PAGOS = (CFG.pagos && CFG.pagos.length ? CFG.pagos : ['Tarjeta de crédito o débito', 'OXXO', 'Mercado Pago']);

  /* ---------- Utilidades ---------- */
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const compacto = (s) => norm(s).replace(/ /g, '');
  const pesos = (n) => `$${(Math.round(Number(n) * 100) / 100).toLocaleString('es-MX', { maximumFractionDigits: 2 })}`;
  const piezasTxt = (n) => `${n} ${n === 1 ? 'pieza' : 'piezas'}`;
  const waUrl = (msg) => (WA ? `https://wa.me/${WA}?text=${encodeURIComponent(msg)}` : (R.contacto || `${RAIZ}/pages/contact`));
  const accionWa = (texto, msg) => ({ texto, href: waUrl(msg || `Hola, ${NEGOCIO}. Tengo una pregunta.`) });
  const verCarrito = { texto: 'Ver mi carrito', tipo: 'ver' };
  const tarifa = (g) => { for (const [tope, n, pr] of ENVIO) if (tope === null || g <= tope) return { n, pr }; return { n: '', pr: ENVIO[ENVIO.length - 1][2] }; };
  const tablaEnvio = ENVIO.map(([, n, pr]) => `${n.toLowerCase()}: **${pesos(pr)}**`).join(', ');
  const listaPagosBold = PAGOS.map((x) => `**${/^(OXXO|Mercado|PayPal)/i.test(x) ? x : x.charAt(0).toLowerCase() + x.slice(1)}**`);
  const pagosTxt = listaPagosBold.length > 1 ? `${listaPagosBold.slice(0, -1).join(', ')} o ${listaPagosBold[listaPagosBold.length - 1]}` : listaPagosBold[0];

  /* ---------- Piezas de la tienda (/products.json) ---------- */
  let PRODUCTOS = [];
  const PRODS = {};
  let MARCAS = [];
  // Lee la descripción: texto, presentación y equivalencias/claves de la tabla de la ficha técnica.
  // DOMParser no ejecuta nada: solo se leen textos.
  function leerFicha(html) {
    const d = new DOMParser().parseFromString(String(html || ''), 'text/html');
    let pres = 'Pieza';
    const eq = [];
    d.querySelectorAll('tr').forEach((tr) => {
      const th = tr.querySelector('th');
      const td = tr.querySelector('td');
      if (!th || !td) return;
      const k = norm(th.textContent);
      const v = td.textContent.replace(/\s+/g, ' ').trim();
      if (!v) return;
      if (k.startsWith('presentaci')) pres = v;
      if (k.includes('equivalencia') || k.includes('clave') || k.includes('oem') || k === 'modelo') eq.push(v);
    });
    const texto = (d.body.textContent || '').replace(/\s+/g, ' ').trim();
    return { pres, eq: eq.join(', '), texto };
  }

  function cargarPiezas() {
    return fetch(`${RAIZ}/products.json?limit=250`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((j) => {
        PRODUCTOS = (j.products || []).map((p) => {
          const v = (p.variants || [])[0] || {};
          const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map((t) => t.trim());
          const vn = norm(p.vendor);
          const marca = p.vendor && vn !== norm(NEGOCIO) && vn !== 'diesmax' ? p.vendor : '';
          const f = leerFicha(p.body_html);
          const pieza = {
            id: String(v.id || p.id), handle: p.handle, n: p.title, np: v.sku || p.title, marca,
            cat: p.product_type || '', p: Number(v.price) || 0, peso: Number(v.grams) || 0,
            disponible: v.available !== false, soloZac: tags.includes('solo-zacatecas'),
            pres: f.pres, eq: f.eq,
          };
          const txt = norm(`${pieza.np} ${pieza.n} ${marca} ${pieza.cat} ${pieza.pres} ${tags.join(' ')} ${f.eq} ${f.texto}`);
          pieza.idx = { txt, comp: txt.replace(/ /g, ''), np: compacto(pieza.np) };
          PRODS[pieza.id] = pieza;
          return pieza;
        });
        MARCAS = [...new Set(PRODUCTOS.map((p) => p.marca).filter(Boolean))];
      })
      .catch(() => {});
  }

  /* ---------- Búsqueda: número de parte, equivalencia, clave, marca o nombre (igual que v3) ---------- */
  const VACIAS = new Set(['de', 'del', 'la', 'el', 'los', 'las', 'para', 'con', 'un', 'una', 'y', 'o', 'en', 'a', 'tienen', 'tienes', 'hay', 'venden', 'manejan', 'quiero', 'necesito', 'busco', 'me', 'mi', 'precio', 'cuanto', 'cuesta', 'vale', 'que', 'por', 'numero', 'parte', 'no', 'pieza', 'piezas']);
  const escRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  function buscar(texto) {
    const qn = norm(texto);
    if (!qn) return [];
    const qc = qn.replace(/ /g, '');
    const toks = qn.split(' ').filter((w) => w && !VACIAS.has(w));
    const pal = qn.split(' ');
    const trozos = [];
    for (let i = 0; i < pal.length; i++) for (let j = i + 1; j <= Math.min(pal.length, i + 3); j++) trozos.push(pal.slice(i, j).join(''));
    const res = [];
    PRODUCTOS.forEach((p) => {
      const { txt, comp, np } = p.idx;
      let pts = 0;
      if (qc.length >= 3) {
        if (np === qc) pts += 100;
        else if (np.startsWith(qc)) pts += 60;
        else if (np.includes(qc)) pts += 40;
      }
      if (pts < 100 && trozos.some((c) => c === np)) pts += 100;
      // Equivalencia o clave exacta de la ficha (FF213 → GP-11)
      if (pts < 100 && qc.length >= 3 && p.eq.split(/,\s*/).some((x) => compacto(x.replace(/\(.*?\)/g, '')) === qc)) pts += 90;
      let todas = toks.length > 0;
      toks.forEach((w) => {
        const vs = [w];
        if (w.length > 4 && w.endsWith('es')) vs.push(w.slice(0, -2));
        if (w.length > 3 && w.endsWith('s')) vs.push(w.slice(0, -1));
        const ok = vs.some((v) => new RegExp(`(^| )${escRe(v)}`).test(txt) || (/\d/.test(v) && v.length >= 3 && comp.includes(v)));
        if (ok) pts += /\d/.test(w) ? 6 : 4; else todas = false;
      });
      if (pts >= 40 || (todas && pts > 0)) res.push([p, pts]);
    });
    return res.sort((a, b) => b[1] - a[1] || PRODUCTOS.indexOf(a[0]) - PRODUCTOS.indexOf(b[0])).map(([p]) => p);
  }
  // ¿El texto coincide con una equivalencia o clave (y no con el número de parte)?
  function porEquivalencia(p, texto) {
    const qc = compacto(texto);
    if (qc.length < 3 || compacto(p.np).includes(qc)) return '';
    return p.eq.split(/,\s*/).find((x) => compacto(x).includes(qc)) || '';
  }
  const pareceNumeroDeParte = (t) => { const x = String(t).trim(); return /\d{2,}/.test(x) && x.split(/\s+/).length <= 3 && /^[a-z0-9\-_ ./]+$/i.test(x); };
  const urlProd = (p) => `${RAIZ}/products/${p.handle}`;
  const compat = (p) => `Hola, ${NEGOCIO}. ¿El ${p.np} (${p.n}) le queda a mi camión?\nMarca, modelo y año: \nNúmero de serie o VIN: `;
  const minus = (s) => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);
  const tarjetaAsis = (p) => ({
    titulo: `${p.np} · ${p.n}`,
    href: urlProd(p),
    detalle: `${p.marca ? `${p.marca} · ` : ''}${p.pres}${p.soloZac ? ' · Solo Zacatecas' : ''}${p.disponible ? '' : ' · Agotado en línea'}`,
    precio: pesos(p.p),
    boton: p.disponible ? { texto: 'Agregar', hecho: 'Agregado ✓', tipo: 'agregar', id: p.id } : null,
  });

  /* ---------- Carrito (el de Shopify, /cart.js) ---------- */
  let CARRITO = { items: [], item_count: 0, total_price: 0, total_weight: 0 };
  const leerCarrito = () => fetch(`${RAIZ}/cart.js`, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : CARRITO)).then((c) => { CARRITO = c || CARRITO; return CARRITO; }).catch(() => CARRITO);
  document.addEventListener('dm:carrito', () => { leerCarrito(); });
  const enCarrito = (id) => (CARRITO.items || []).filter((i) => String(i.variant_id) === String(id)).reduce((s, i) => s + i.quantity, 0);
  const llevaBateria = () => (CARRITO.items || []).some((i) => PRODS[String(i.variant_id)] && PRODS[String(i.variant_id)].soloZac);

  async function agregar(id) {
    await leerCarrito();
    const p = PRODS[id];
    if (enCarrito(id) >= MAX) return `Ya llevas el máximo de ${MAX} de ${p ? p.np : 'esa pieza'} en línea. Para más, pide precio por volumen por WhatsApp.`;
    try {
      const r = await fetch(`${RAIZ}/cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      const j = await r.json();
      if (!r.ok || j.status) return j.description || j.message || 'No se pudo agregar. Intenta desde la ficha o pide por WhatsApp.';
      if (window.dmCarrito) window.dmCarrito.refrescar();
      const c = await leerCarrito();
      return `Agregué ${p ? p.np : 'la pieza'} al carrito. Llevas ${piezasTxt(c.item_count)} (${pesos(c.total_price / 100)} más envío).`;
    } catch (e) {
      return 'No se pudo agregar. Intenta desde la ficha o pide por WhatsApp.';
    }
  }

  /* ---------- Configuración del asistente ---------- */
  function configurar() {
    window.ASISTENTE = {
      negocio: NEGOCIO,
      titulo: `Asistente de ${NEGOCIO}`,
      subtitulo: 'Te contesta al instante',
      cara: ['M4 6h16v12H4z', 'M8 10h3M8 14h8', 'M15 10h1'],
      colores: { marca: '#1a2744', sobreMarca: '#ffffff', fondo: '#ffffff', tinta: '#161b26', suave: '#eef2f8', linea: '#d9dfea', gris: '#56607a', radio: '6px' },
      boton: 'Pregunta por tu pieza',
      botonSub: 'Número de parte, envíos, factura',
      placeholder: 'Escribe el número de parte o tu pregunta…',
      saludo: `Hola. Dime el número de parte, la marca o qué pieza buscas y te digo si está en la tienda. Si es para saber si le queda a tu camión, te paso con ${NEGOCIO} por WhatsApp.`,
      sugerencias: ['LF670', 'FF213', '¿Cuánto cuesta el envío?', '¿Facturan?', '¿Le queda a mi Kenworth?', 'Grasa para chasis'],
      pie: `Lo de compatibilidad lo confirma ${NEGOCIO} por WhatsApp con tu número de serie o VIN.`,
      temas: [
        { claves: ['le queda', 'queda', 'quedara', 'compatible', 'compatibilidad', 'sirve para', 'aplica', 'aplicacion', 'vin', 'numero de serie', 'modelo', 'kenworth', 'freightliner', 'international', 'peterbilt', 'volvo', 'dina', 'cummins', 'isx', 'detroit', 'mi camion', 'mi tracto', 'mi troca'], prioridad: true,
          respuesta: (t) => {
            const h = buscar(t).slice(0, 3);
            return {
              texto: `Eso no te lo confirmo aquí: para no mandarte una pieza equivocada, ${NEGOCIO} lo revisa con tu **número de serie o VIN**, o con el número de parte de la pieza que traes. Mándalo por WhatsApp y te contestan.`,
              tarjetas: h.map(tarjetaAsis),
              acciones: [accionWa('Preguntar por WhatsApp', h.length === 1 ? compat(h[0]) : `Hola, ${NEGOCIO}. Quiero saber si una pieza le queda a mi camión.\nMarca, modelo y año: \nNúmero de serie o VIN: \nPieza: ${t}`)],
              seguir: ['¿Cuánto cuesta el envío?', '¿Cómo pago?'],
            };
          } },
        { claves: ['envio', 'envios', 'envian', 'mandan', 'llega', 'tarda', 'paqueteria', 'guia', 'entrega', 'rastreo', 'recoger', 'recojo', 'retiro', 'flete'],
          respuesta: () => {
            let extra = '';
            if (CARRITO.item_count > 0) {
              extra = llevaBateria()
                ? ` Llevas una batería en el carrito: esa se recoge en ${TIENDA} o se entrega en Zacatecas.`
                : ` Con lo que llevas en el carrito (${piezasTxt(CARRITO.item_count)}) el envío sale en **${pesos(tarifa(CARRITO.total_weight).pr)}**.`;
            }
            return {
              texto: `Enviamos a todo México por **paquetería**; el envío lo pagas al comprar y depende del peso: ${tablaEnvio}. Tarda de **${DIAS}**. También puedes **recoger gratis en ${TIENDA}** o pedir **entrega local gratis** hasta ${KM} km en Zacatecas. Las baterías **solo se entregan en Zacatecas**.${extra}`,
              acciones: R.envios ? [{ texto: 'Ver envíos', href: R.envios }] : [],
              seguir: ['¿Cómo pago?', '¿Facturan?', '¿Qué llevo en el carrito?'],
            };
          } },
        { claves: ['pago', 'pagar', 'pagos', 'tarjeta', 'oxxo', 'mercado pago', 'transferencia', 'deposito', 'efectivo', 'credito', 'debito', 'meses'],
          texto: `Pagas con ${pagosTxt}, en el pago seguro de Shopify al terminar tu compra. También puedes armar tu carrito y mandarlo por WhatsApp.`, acciones: [verCarrito] },
        { claves: ['factura', 'facturan', 'facturar', 'facturas', 'cfdi', 'rfc', 'fiscal'],
          texto: 'Sí, emitimos **factura CFDI**. Pídela por WhatsApp con tu **número de pedido** y tu **constancia de situación fiscal**.',
          acciones: [accionWa('Pedir mi factura', `Hola, ${NEGOCIO}. Quiero factura de mi pedido número: \nTe mando mi constancia de situación fiscal.`)].concat(R.factura ? [{ texto: 'Cómo pedirla', href: R.factura }] : []) },
        { claves: ['foto', 'no se el numero', 'no tengo el numero', 'no se como se llama', 'sin numero', 'etiqueta'],
          texto: 'Mándanos por WhatsApp una foto de la pieza o de su etiqueta y, si puedes, el número de serie o VIN del camión. Te decimos qué pieza es, si la tenemos y su precio.', acciones: [accionWa('Mandar foto por WhatsApp', `Hola, ${NEGOCIO}. Les mando foto de la pieza que necesito.`)] },
        { claves: ['taller', 'flotilla', 'refaccionaria', 'mayoreo', 'volumen', 'lista', 'varias piezas', 'cotizacion', 'cotizar', 'descuento'],
          texto: `En línea puedes pedir hasta **${MAX} de cada pieza**. Para más, o para una lista, pide **precio por volumen** por WhatsApp con números de parte y cantidades.`, acciones: [accionWa('Mandar mi lista', `Hola, ${NEGOCIO}. Quiero cotizar esta lista:\n`), verCarrito] },
        { claves: ['ubicacion', 'donde estan', 'direccion', 'zacatecas', 'tienda fisica', 'mapa', 'sucursal'],
          texto: `Estamos en **Zacatecas**: ${TIENDA}, ${String(CFG.direccion || CFG.direccionCorta || '').replace(/\.+$/, '')}. Puedes recoger gratis; antes de ir, confirma por WhatsApp que tu pedido está listo.`, acciones: R.contacto ? [{ texto: 'Ver contacto y mapa', href: R.contacto }] : [] },
        { claves: ['horario', 'hora', 'abren', 'cierran', 'abierto'],
          texto: 'El horario no está publicado en la tienda en línea. Pregúntalo por WhatsApp antes de ir a recoger.', acciones: [accionWa('Preguntar el horario', `Hola, ${NEGOCIO}. ¿Qué horario tienen para recoger?`)] },
        { claves: ['devolucion', 'devoluciones', 'devolver', 'cambio', 'cambiar', 'equivocada', 'reembolso'],
          texto: `Tienes **7 días naturales** desde que recibes tu pedido. La pieza debe estar nueva, sin instalar y en su empaque original. Pídela por WhatsApp${CORREO ? ` o a ${CORREO}` : ''} con tu número de pedido y una foto.`,
          acciones: (R.devoluciones ? [{ texto: 'Ver la política', href: R.devoluciones }] : []).concat([accionWa('Pedir una devolución', `Hola, ${NEGOCIO}. Quiero pedir una devolución de mi pedido número: `)]) },
        { claves: ['garantia', 'defecto', 'fallo', 'fallas', 'salio mala'],
          texto: CORREO ? `Para reclamar la garantía, escríbenos a **${CORREO}** con tu número de pedido y una foto de la pieza.` : 'Para reclamar la garantía, escríbenos por WhatsApp con tu número de pedido y una foto de la pieza.',
          acciones: CORREO ? [{ texto: 'Escribir correo', href: `mailto:${CORREO}` }, accionWa('Escribir por WhatsApp', `Hola, ${NEGOCIO}. Quiero reclamar la garantía de mi pedido número: `)] : [accionWa('Escribir por WhatsApp', `Hola, ${NEGOCIO}. Quiero reclamar la garantía de mi pedido número: `)] },
        { claves: ['carrito', 'llevo', 'mi pedido', 'total'],
          respuesta: () => {
            const ls = CARRITO.items || [];
            if (!ls.length) return { texto: 'Tu carrito está vacío. Dime qué número de parte buscas.' };
            return { texto: `Llevas:\n${ls.map((i) => `${i.quantity} × ${i.sku || i.product_title} · ${i.product_title}`).join('\n')}\n\nSubtotal: **${pesos(CARRITO.total_price / 100)}** más envío`, acciones: [verCarrito] };
          } },
        { claves: MARCAS.map((m) => m.toLowerCase()).concat(['marca', 'marcas']),
          respuesta: (t, tn) => {
            const m = MARCAS.find((x) => tn.split(' ').includes(norm(x)) || tn.includes(norm(x)));
            if (m) return { texto: `De **${m}** tenemos esto en la tienda:`, tarjetas: PRODUCTOS.filter((p) => p.marca === m).slice(0, 6).map(tarjetaAsis) };
            return { texto: MARCAS.length ? `En la tienda hay piezas ${MARCAS.join(', ')}.` : 'Pregúntanos por la marca que buscas.', acciones: R.marcas ? [{ texto: 'Ver por marca', href: R.marcas }] : [] };
          } },
        { claves: ['original', 'originales', 'generico', 'genericas', 'calidad'],
          texto: 'En la ficha de cada pieza ves su marca y su número de parte. Si necesitas algo en específico, pregúntanos por WhatsApp antes de comprar.', acciones: [accionWa('Preguntar por WhatsApp')] },
      ],
      buscar: (texto, tn) => {
        // Si escribió solo el nombre de una marca, contesta el tema de marcas (sus piezas)
        if (MARCAS.some((m) => norm(m) === tn)) return null;
        const h = buscar(texto);
        if (!h.length) {
          if (pareceNumeroDeParte(texto)) {
            return { fuerte: true, texto: `No encontré **${texto.trim()}** en la tienda en línea. Puede que sí la tengamos o la consigamos: mándanos el número por WhatsApp.`, acciones: [accionWa('Preguntar por WhatsApp', `Hola, ${NEGOCIO}. ¿Tienen el número de parte ${texto.trim()}?`)] };
          }
          return null;
        }
        const soloUnaEq = !!porEquivalencia(h[0], texto) && !h.slice(1).some((p) => porEquivalencia(p, texto));
        const exacto = h.length === 1 || compacto(h[0].np) === compacto(texto) || soloUnaEq;
        if (exacto) {
          const p = h[0];
          const eq = porEquivalencia(p, texto);
          const estado = p.soloZac ? ' Solo se entrega en Zacatecas o se recoge en la tienda.' : (p.disponible ? '' : ' Por ahora está agotado en línea; pregúntanos por WhatsApp.');
          return {
            fuerte: true,
            texto: `Sí está: **${p.np}**, ${p.n}${eq ? ` (equivale a ${eq})` : ''}. Precio: **${pesos(p.p)}** con IVA, ${minus(p.pres)}.${estado}`,
            tarjetas: [tarjetaAsis(p)],
            acciones: [{ texto: 'Ver ficha', href: urlProd(p) }, accionWa('¿Le queda a mi camión?', compat(p))],
            seguir: ['¿Cuánto cuesta el envío?', '¿Facturan?', '¿Qué llevo en el carrito?'],
          };
        }
        return { fuerte: h.length <= 8 && !/\b(le queda|compatible)\b/.test(tn), texto: `Encontré ${piezasTxt(h.length)} en la tienda:`, tarjetas: h.slice(0, 6).map(tarjetaAsis), acciones: [{ texto: 'Ver en el catálogo', href: `${R.buscar || `${RAIZ}/search`}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(texto.trim().slice(0, 60))}` }], seguir: ['¿Cuánto cuesta el envío?', '¿Qué llevo en el carrito?'] };
      },
      alAccion: (a) => {
        if (a.tipo === 'agregar' && PRODS[a.id]) {
          agregar(a.id).then((msg) => { if (window.asistente && window.asistente.decir) window.asistente.decir(msg); });
          return true;
        }
        if (a.tipo === 'ver') {
          if (window.asistente) window.asistente.cerrar();
          if (window.dmCarrito) window.dmCarrito.abrir(); else location.href = R.carrito || `${RAIZ}/cart`;
          return true;
        }
        return false;
      },
      respaldo: { texto: `Eso no lo encontré en la tienda en línea. Escríbeme el número de parte o la marca, o pregúntale directo a ${NEGOCIO} por WhatsApp (puedes mandar foto de la pieza).`, acciones: [accionWa('Preguntar por WhatsApp')], respaldo: true },
    };
    const s = document.createElement('script');
    s.src = CFG.asistente;
    s.defer = true;
    document.body.append(s);
  }

  const arrancar = () => Promise.all([cargarPiezas(), leerCarrito()]).then(configurar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
